/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { createRouteMapper } from './route-mapper'
import { handleGetRequest } from './get-handlers'
import { handlePostRequest } from './post-handlers'
import {
  isKibanaInternalRequest,
  createKibanaRequestError,
  createNotImplementedError,
} from './utils'

import type { HttpClient, StackDeployment } from './types'

// Handle routing and normalization of requests to various console endpoints
export const createHttpClient = (deployment: StackDeployment): HttpClient => {
  const mapRoute = createRouteMapper(deployment)

  return {
    get: async (path: string, options?: any) => {
      if (isKibanaInternalRequest(options)) {
        return createKibanaRequestError()
      }

      return handleGetRequest(path, deployment, mapRoute, options) as any
    },

    post: async (path: string, body?: any, options?: any) => {
      if (isKibanaInternalRequest(options)) {
        return createKibanaRequestError()
      }

      return handlePostRequest(path, body, deployment, mapRoute, options)
    },

    put: async (_path: string, _body?: any, options?: any) => {
      if (isKibanaInternalRequest(options)) {
        return createKibanaRequestError()
      }

      return createNotImplementedError('PUT')
    },

    patch: async (_path: string, _body?: any, options?: any) => {
      if (isKibanaInternalRequest(options)) {
        return createKibanaRequestError()
      }

      return createNotImplementedError('PATCH')
    },

    delete: async (_path: string, options?: any) => {
      if (isKibanaInternalRequest(options)) {
        return createKibanaRequestError()
      }

      return createNotImplementedError('DELETE')
    },

    head: async (_path: string, options?: any) => {
      if (isKibanaInternalRequest(options)) {
        return createKibanaRequestError()
      }

      return createNotImplementedError('HEAD')
    },
  }
}

export type { HttpClient, StackDeployment } from './types'
